import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { isoUUID } from '@macs-frontend/core/utils/uuid';
import { ProjectSorter, ProjectStatuses } from '@macs-frontend/web-macs/shared';
import { environment } from '../../../../../environments/environment';
import { ProjectGroup } from '../../models/project-group';
import { ProjectSortTypes } from '../../models/project-sort-types';
import { Projects } from '../../models/projects';
import { ProjectCalculations } from '../../utils/project-calculations';

interface ExpandedProjectGroups {
  [groupId: string]: boolean;
}

@Component({
  selector: 'md-projects-grouped',
  templateUrl: 'projects-grouped.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsGroupedComponent extends BaseComponent implements OnChanges {
  ProjectStatuses = ProjectStatuses;
  sorterTypes = ProjectSortTypes;

  @Input() groups: ProjectGroup[] = [];
  // @ts-expect-error
  @Input() sorter: ProjectSorter;

  @Output()
  archiveAction: EventEmitter<Projects> = new EventEmitter<Projects>();
  @Output()
  restoreAction: EventEmitter<Projects> = new EventEmitter<Projects>();
  @Output() deleteAction: EventEmitter<Projects> = new EventEmitter<Projects>();
  @Output()
  duplicateAction: EventEmitter<Projects> = new EventEmitter<Projects>();
  @Output()
  sort: EventEmitter<ProjectSortTypes> = new EventEmitter<ProjectSortTypes>();

  getBudget = ProjectCalculations.getBudget;

  imagesPath = environment.images_path;
  expandedGroups: ExpandedProjectGroups = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.groups && changes.groups.currentValue) {
      const groups: ProjectGroup[] = changes.groups.currentValue;
      this.expandedGroups = groups.reduce(
        (
          expandedGroups: ExpandedProjectGroups,
          group: ProjectGroup,
        ): ExpandedProjectGroups => {
          expandedGroups[isoUUID.unwrap(group.uuid)] = true;
          return expandedGroups;
        },
        {},
      );
    }
  }

  archive(project: Projects) {
    this.archiveAction.emit(project);
  }

  duplicate(project: Projects) {
    this.duplicateAction.emit(project);
  }

  delete(project: Projects) {
    this.deleteAction.emit(project);
  }

  restore(project: Projects) {
    this.restoreAction.emit(project);
  }

  sortBy(type: ProjectSortTypes) {
    this.sort.emit(type);
  }

  toggleExpandGroup(id: string) {
    this.expandedGroups[id] = !this.expandedGroups[id];
  }
}
